import { EventEmitter } from '@angular/core';

import { DragAndDropService, DragAndDropEvent } from '../drag-and-drop.service';

import { Draggable } from './draggable';

export class DropZone {
  constructor(
    private _service: DragAndDropService,
    public readonly id: number,
    public readonly element: HTMLElement
  ) {
    this._service.addEventListener(this.element, 'dragenter', this._onDragEnter);
    this._service.addEventListener(this.element, 'dragover', this._onDragOver, true);
    this._service.addEventListener(this.element, 'drop', this._onDrop);
  }

  public enabled = true;
  public dragging_over = false;
  public children: Array<Draggable> = [];

  public restriction: string | string[] = null;

  public onEnter: EventEmitter<DragAndDropEvent> = new EventEmitter();
  public onLeave: EventEmitter<DragAndDropEvent> = new EventEmitter();
  public onDrop: EventEmitter<DragAndDropEvent> = new EventEmitter();
  public onRemove: EventEmitter<DragAndDropEvent> = new EventEmitter();

  public $onEnter: EventEmitter<DragEvent> = new EventEmitter();
  public $onLeave: EventEmitter<DragEvent> = new EventEmitter();
  public $onDrop: EventEmitter<DragEvent> = new EventEmitter();

  public setEnabled(enabled: boolean): void {
    this.enabled = !!enabled;
  }

  public setDraggingOver(dragging_over: boolean): void {
    this.dragging_over = !!dragging_over;
  }

  public setRestriction(restriction: string | string[]): void {
    this.restriction = restriction;
  }

  public setDraggableChildren(children: Array<Draggable>) {
    this.children = children;
  }

  public destroy() {
    this._service.removeEventListener(this.element, 'dragenter', this._onDragEnter);
    this._service.removeEventListener(this.element, 'dragover', this._onDragOver);
    this._service.removeEventListener(this.element, 'drop', this._onDrop);
  }

  private _onDragEnter = (event: DragEvent): void => {
    if (!this.enabled) { return; }

    if (this.element === event.target || this.element.contains(<Node>event.target)) {
      this.$onEnter.emit(event);
    }
  }

  private _onDragOver = (event: DragEvent): void => {
    if (!this._service.isDropZoneRestricted(this)) { event.preventDefault(); }
  }

  private _onDrop = (event: DragEvent): void => {
    this.$onDrop.emit(event);
  }
}
